import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { REGISTER_URL } from '../../pricing';

const { FiCheckCircle } = FiIcons;

const Solution = () => {
  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            พิธีไหว้เจ้าพ่อเขาใหญ่
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            แนะนำการไหว้และขอพรอย่างถูกต้องตามหลักความเชื่อโบราณ
          </p>
        </motion.div>

        {/* Image Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-2xl shadow-xl"
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752686147775-blob"
              alt="บรรยากาศพิธีกรรม"
              className="w-full h-[300px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
              <h3 className="text-xl font-bold">บรรยากาศพิธีกรรม</h3>
              <p className="text-sm opacity-90">จากครั้งที่ผ่านมา</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-2xl shadow-xl"
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752686162584-blob"
              alt="การไหว้ขอพร"
              className="w-full h-[300px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
              <h3 className="text-xl font-bold">การไหว้ขอพร</h3>
              <p className="text-sm opacity-90">ตามหลักความเชื่อโบราณ</p>
            </div>
          </motion.div>
        </div>

        {/* Additional Images */}
        <div className="grid md:grid-cols-2 gap-8">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-2xl shadow-xl"
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752686191734-blob"
              alt="ศาลเจ้าพ่อเขาใหญ่"
              className="w-full h-[300px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
              <h3 className="text-xl font-bold">ศาลเจ้าพ่อเขาใหญ่</h3>
              <p className="text-sm opacity-90">สถานที่ศักดิ์สิทธิ์คู่เกาะสีชัง</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-2xl shadow-xl"
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752686214450-blob"
              alt="บรรยากาศการทำพิธี"
              className="w-full h-[300px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
              <h3 className="text-xl font-bold">บรรยากาศการทำพิธี</h3>
              <p className="text-sm opacity-90">ความศรัทธาและความเชื่อ</p>
            </div>
          </motion.div>
        </div>

        <div className="mt-8 text-center">
          <a
            href={REGISTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-bold rounded-full hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            ลงทะเบียนเข้าร่วมทริปนี้
          </a>
        </div>
      </div>
    </section>
  );
};

export default Solution;